import LogDateTimeInput from "../../../components/LogDateTimeInput";
import { localLogDateTime, logDateTimePayload } from "../../../utils/logDateTime";
import { Button, message, Radio, Upload } from "antd";
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { ErrorToast, SuccessToast } from "../../../widgets/AppToast";
import SelectInput from "../../../components/SelectInput";
import AppInput from "../../../components/AppInput";
import TextArea from "antd/es/input/TextArea";
import { post } from "../../../services/services";
import { ApiURL } from "../../../services/apiConstants";
import VoyageDetails from "../../../components/VoyageDetails";
import { garbageType, methodofDisposal } from "../../../Data/data";
import useDocumentUpload from "../../../hooks/useDocumentUpload";
import { UploadOutlined } from "@ant-design/icons";
import useUserData from "../../../hooks/useUserData";

function AddGarbageLog() {
  const navigate = useNavigate();
  const user = useUserData();
  const designation = user?.data?.designation;
  const [loader, set_loader] = useState(false);
  const [errors, set_errors] = useState({});
  const [captureNow, setCaptureNow] = useState(false);
  const [staff_dashboard, set_staff_dashboard] = useState([]);
  const [garbage_type, set_garbage_type] = useState("");
  const [qtty_disposed, set_qtty_disposed] = useState("");
  const [method_of_disposal, set_method_of_disposal] = useState("");
  const [if_disposed, set_If_disposed] = useState("no");
  const [free_Text, set_Free_Text] = useState("");
  const [position, setPosition] = useState("");
  const [digitalSignatureIncharge, setDigitalSignatureIncharge] = useState("");
  const [logDate, set_LogDate] = useState(localLogDateTime);
  const { documentList, handleDocumentChange, getFilesForUpload } = useDocumentUpload();
  const [previous_log_date, set_Previous_Log_Date] = useState("");

  const GET_PREVIUS_LOG_DATE = () => {
    const FORM_DATA = new FormData();
     FORM_DATA.append("garbage_part", "1");
    post(ApiURL.garbage_last_date_st, FORM_DATA).then((res) => {
      if (res?.status === true) {
        const previusDate = res?.laast_record;
        set_Previous_Log_Date(previusDate);
      }
    });
  };

  const SEND_NOTIFICATION_MASTER = async (record_id) => {
    try {
      const FORM_DATA = new FormData();
      FORM_DATA.append("voyage_id", staff_dashboard?.voyage_details?.[0]?.id);
      FORM_DATA.append("grb_part", "1");
      FORM_DATA.append("record_id", record_id);
      FORM_DATA.append(
        "description",
        "A new Garbage Part 1 record has been created. Please review and confirm it at your earliest convenience"
      );
      const response = await post(ApiURL?.requests_notification_grb_st, FORM_DATA);
      if (response?.status === true) {
        SuccessToast("Congratulations!", response?.message || "No message returned.");
      } else {
        ErrorToast("Error", response?.message || "Something went wrong.");
      }
    } catch (error) {
      ErrorToast("Request Failed", "Could not complete the request. Please try again.");
    }
  };

  const ADD_GARBAGE_LOGBOOK_APIS = () => {
    const files = getFilesForUpload();
    set_loader(true);
    const FORM_DATA = new FormData();
    FORM_DATA.append("voyage_id", staff_dashboard?.voyage_details?.[0]?.id);
    FORM_DATA.append("garbage_type", garbage_type);
    FORM_DATA.append("quantity_disposed", qtty_disposed);
    FORM_DATA.append("method_of_disposal", method_of_disposal);
    FORM_DATA.append("disposed", if_disposed ? 1 : 0);
    FORM_DATA.append("comment", free_Text);
    FORM_DATA.append("log_date_time", logDateTimePayload(logDate, captureNow));
    FORM_DATA.append("garbage_part", "1");
    FORM_DATA.append("position", position);
    FORM_DATA.append("signature", digitalSignatureIncharge);
    files?.forEach((files) => {

      FORM_DATA.append("files", files);
    });

    post(ApiURL.add_garbage_details_st, FORM_DATA).then((res) => {
      if (res?.status == true) {
        SuccessToast("Congratulation!!", "Garbage logbook Details Successfully Created!!");
        navigate("/list-garbage-log");
        set_loader(false);
        if (designation && designation !== "Captain") {
          SEND_NOTIFICATION_MASTER(res?.data?.id);
        }
      } else {
        ErrorToast("Error message", res?.message);
        const errors = res?.errors || {};
        set_errors(errors);
        set_loader(false);
      }
    });
  };

  const getDocUrl = (file) => {
    if (file.url) return file.url; // existing file
    if (file.originFileObj) return URL.createObjectURL(file.originFileObj); // newly uploaded
    return null;
  };

  const handlePreviews = async (file) => {
    const url = getDocUrl(file);
    if (!url) {
      message.error("No preview available for this file");
      return;
    }
    window.open(url, "_blank");
  };

  useEffect(() => {
    const staff_dashboards = localStorage.getItem("staff_dashboard");
    const parsedData = JSON.parse(staff_dashboards);
    set_staff_dashboard(parsedData);
    GET_PREVIUS_LOG_DATE();
  }, []);

  return (
    <>
      <VoyageDetails staff_dashboard={staff_dashboard?.voyage_details} />
      <div className="white-container">
        <br />
        <h3>Garbage Logbook Information </h3>
        <div className="row">
          <div className="col-6">
            <LogDateTimeInput value={logDate} onChange={set_LogDate}
              captureNow={captureNow} onCaptureChange={setCaptureNow}
              error={errors.log_date_time} min={previous_log_date} />
          </div>
          <div className="col-6">
            <SelectInput
              label="Garbage Type"
              value={garbage_type}
              placeholder=" -- Garbage Type  -- "
              style={{ width: "100%" }}
              onChange={(value) => set_garbage_type(value)}
              options={garbageType}
              errors={errors?.selectedTank}
            />
          </div>
        </div>
        <div className="row" style={{ marginBottom: "10px" }}>
          <div className="col-6">
            <label className="block-label">If disposed</label>
            <Radio.Group value={if_disposed} onChange={(e) => set_If_disposed(e.target.value)}>
              <Radio value={"no"}>NO</Radio>
              <Radio value={"yes"}>Yes</Radio>
            </Radio.Group>
            {errors?.voyage_status && <span style={{ color: "red" }}>{errors?.voyage_status}</span>}
          </div>
        </div>
        {if_disposed === "yes" && (
          <>
            <div className="row">
              <div className="col-6">
                <SelectInput
                  label="Method of Disposal"
                  placeholder="-- Method of Disposal --"
                  style={{ width: "100%" }}
                  value={method_of_disposal}
                  onChange={(value) => set_method_of_disposal(value)}
                  options={methodofDisposal}
                  errors={errors?.method_of_disposal}
                />
              </div>
              <div className="col-6">
                <AppInput
                  label="Qnty disposed (m3)"
                  placeholder="Qnty disposed"
                  value={qtty_disposed}
                  onChange={(e) => set_qtty_disposed(e.target.value)}
                  errors={errors?.qtty_disposed}
                />
              </div>
            </div>

            <div className="row">
              <div className="col-6">
                <AppInput
                  label="Position"
                  placeholder="Enter Position"
                  value={position}
                  onChange={(e) => setPosition(e.target.value)}
                  errors={errors?.position}
                />
              </div>
              <div className="col-6">
                <AppInput
                  label="Digital Signature (Incharge)"
                  placeholder="Enter Digital Signature"
                  value={digitalSignatureIncharge}
                  onChange={(e) => setDigitalSignatureIncharge(e.target.value)}
                  errors={errors?.digitalSignatureIncharge}
                />
              </div>
            </div>
          </>
        )}

        <div className="row">
          <div className="col-6">
            <div className="input-box">
              <label>
                Garbage Comments: (e.g. start/stop time and position of incineration; general
                Comments)
              </label>
              <TextArea
                rows={1}
                placeholder="Garbage Comments"
                maxLength={1000}
                value={free_Text}
                onChange={(e) => set_Free_Text(e.target.value)}
              />
            </div>
          </div>
          <div className="col-6">
            <div
              className="input-box"
              style={{
                display: "flex",
                flexDirection: "column",
                gap: "8px",
                alignItems: "flex-start",
              }}
            >
              <label>Select File</label>
              <Upload
                accept=".pdf,.doc,.docx,.xls,.xlsx"
                multiple
                fileList={documentList}
                onChange={handleDocumentChange}
                onPreview={handlePreviews}
                beforeUpload={() => false}
                listType="picture"
              >
                <Button
                  icon={<UploadOutlined />}
                  type="primary"
                  style={{
                    borderRadius: "50%",
                    padding: "10px",
                    width: "40px",
                    height: "40px",
                    marginLeft: "10px",
                  }}
                ></Button>
              </Upload>
            </div>
          </div>
        </div>
        <div className="row">
          <div className="input-box" style={{ marginTop: "15px", marginLeft: "10px" }}>
            <Button
              loading={loader}
              style={{
                fontSize: "12px",
                color: "#fff",
              }}
              className="save_btn"
              onClick={ADD_GARBAGE_LOGBOOK_APIS}
            >
              Save
            </Button>
          </div>
        </div>
      </div>
    </>
  );
}

export default AddGarbageLog;
